import { useTranslation } from 'next-i18next';
import { FC, ReactNode } from 'react';
import boatCategories from 'src/common/boatCategories';
import UniversalLink from 'src/common/components/UniversalLink';
import { PATHS } from 'src/common/constants';
import Typography from 'src/common/components/Typography';
import styles from './Categories.module.scss';

type TopLevelCategory = {
  /** The i18n key that should be used for the top level category title */
  title: string;
  /** Optional category id that this top level category should link to */
  link?: number;
  /** Category ids that should be listed below this top level category */
  subCategories: number[];
};

const categories: TopLevelCategory[] = [
  { title: 'category-1-short', link: 1, subCategories: [31, 33, 34] },
  { title: 'category-17', link: 17, subCategories: [29, 60, 65, 83, 84, 86, 87] },
  {
    title: 'category-15',
    subCategories: [
      64,
      66,
      67,
      36,
      37,
      35,
      61,
      62,
      69,
      63,
      68,
    ],
  },
  { title: 'category-7-short', subCategories: [13, 7] },
  { title: 'category-4-short', link: 4, subCategories: [42] },
  { title: 'category-1007-short', link: 1007, subCategories: [] },
  { title: 'category-1002-short', link: 1002, subCategories: [] },
  { title: 'category-78', link: 78, subCategories: [] },
];

type ConditionalLinkProps = {
  link?: number;
  children: ReactNode;
};

const ConditionalLink: FC<ConditionalLinkProps> = ({ link, children }) => (
  link ? (
    <UniversalLink
      href={`${PATHS.SEARCH}${boatCategories[link]}/`}
      className={styles.link}
    >
      {children}
    </UniversalLink>
  ) : children
);

const Categories: FC = () => {
  const [t] = useTranslation('boat-categories');
  return (
    <div className={styles.root}>
      {categories.map((category) => (
        <div key={category.title} className={styles.category}>
          <ConditionalLink
            link={category.link}
          >
            <div className={styles.title}>
              <Typography
                type="h2"
                size="display-5"
              >
                {t(category.title)}
              </Typography>
            </div>
          </ConditionalLink>
          {category.subCategories.length > 0 && (
            <ul className={styles.list}>
              {category.subCategories.map((subCategoryId: number) => (
                <li
                  key={boatCategories[subCategoryId]}
                  className={styles.listItem}
                >
                  <UniversalLink
                    href={`${PATHS.SEARCH}${boatCategories[subCategoryId]}/`}
                    className={styles.link}
                  >
                    <Typography
                      type="p"
                      size="body-l"
                    >
                      {t(`category-${subCategoryId}`)}
                    </Typography>
                  </UniversalLink>
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
};

export default Categories;
